import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useCanAnnotateCentralizedPublicClip } from "~/components/Annotations/hooks/useCanAnnotateCentralizedPublicClip";
import { PublicBoardAssetNavigationArrows } from "~/components/AssetModalV2/Header/PublicBoardAssetComponents/PublicBoardAssetNavigationArrows";
import { ImageVisualizer } from "~/components/AssetModalV2/Visualizer/ImageVisualizer/ImageVisualizer";
import { FullscreenOverlay } from "~/components/AssetModalV2/Visualizer/shared/components/FullscreenOverlay";
import { useURLBoardIdSelector } from "~/hooks/useURLBoardIdSelector";
export const PublicImageVisualizer = /*#__PURE__*/ memo(()=>{
    const { canEditAnnotation } = useCanAnnotateCentralizedPublicClip();
    const boardId = useURLBoardIdSelector();
    return /*#__PURE__*/ _jsx(ImageVisualizer, {
        canAnnotateClip: canEditAnnotation,
        fullscreenChildren: /*#__PURE__*/ _jsx(FullscreenOverlay, {
            navigationArrows: boardId ? /*#__PURE__*/ _jsx(PublicBoardAssetNavigationArrows, {}) : null
        }),
        children: ()=>null
    });
});
PublicImageVisualizer.displayName = "PublicImageVisualizer";
